<template>
  <div>
    <div
        class="sm:w-[357px] sm:h-[316px] w-[300px] h-[265px] relative overflow-hidden rounded-[36px] shadow-md sm:shadow-none"
    >
      <img
          src="@/assets/images/powerballPlay-bg.svg"
          alt="Powerball Card Background"
          class="absolute inset-0 w-full h-full object-cover"
      />
      <div class="absolute inset-0 flex flex-col justify-between p-6">
        <h1 class="text-red text-3xl sm:text-4xl font-bold mt-3 sm:mt-4">
          Powerball Play
        </h1>

        <div class="flex justify-center items-center space-x-1 mt-4 sm:mt-3">
          <div class="flex flex-col items-center">
            <span
                class="text-xl sm:text-2xl font-bold bg-blue text-white w-12 h-12 sm:w-14 sm:h-14 rounded-xl mb-1 flex justify-center items-center"
            >{{ days }}</span
            >
            <span class="text-paleBlue font-medium">D</span>
          </div>
          <span class="text-xl font-medium text-paleBlue">:</span>
          <div class="flex flex-col items-center">
            <span
                class="text-xl sm:text-2xl font-bold bg-blue text-white w-12 h-12 sm:w-14 sm:h-14 rounded-xl mb-1 flex justify-center items-center"
            >{{ hours }}</span
            >
            <span class="text-paleBlue font-medium">H</span>
          </div>
          <span class="text-xl font-medium text-paleBlue">:</span>
          <div class="flex flex-col items-center">
            <span
                class="text-xl sm:text-2xl font-bold bg-blue text-white w-12 h-12 sm:w-14 sm:h-14 rounded-xl mb-1 flex justify-center items-center"
            >{{ minutes }}</span
            >
            <span class="text-paleBlue font-medium">M</span>
          </div>
          <span class="text-xl sm:text-2xl font-medium text-paleBlue">:</span>
          <div class="flex flex-col items-center">
            <span
                class="text-xl sm:text-2xl font-bold bg-blue text-white w-12 h-12 sm:w-14 sm:h-14 rounded-xl mb-1 flex justify-center items-center"
            >{{ seconds }}</span
            >
            <span class="text-paleBlue font-medium">S</span>
          </div>
        </div>

        <div
            class="flex justify-between space-x-4 mb-7 sm:mt-0 mt-4 px-3 sm:px-6"
        >
          <div class="text-left">
            <p class="text-blue font-semibold">{{getGameTitle()}}</p>
          </div>
          <p class="text-blue text-3xl font-semibold sm:font-bold">$ {{       new Intl.NumberFormat('en-US', {style: 'decimal'}).format(1500) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PowerballCard",
  data() {
    return {
      countdownTimer: null,
      countdownDate: null, // Set your countdown end date/time here
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  },
  mounted() {
    this.startCountdown();
  },
  created() {
    this.countdownDate = new Date("2024-09-17");
  },
  methods: {
    getGameTitle()
    {
    return    "Powerball Play";
    },
    getActiveGame() {
      return window['gameInputs'].activeGames.filter(x => x.active == true)[0];
    },
    startCountdown() {
      this.updateCountdown();

      this.countdownTimer = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },
    updateCountdown() {
      const now = new Date().getTime();
      const distance = this.countdownDate - now;
      if (distance > 0) {
        this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
        this.hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
      } else {
        clearInterval(this.countdownTimer);
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
        return;
      }
      if (this.seconds === 0) {
        if (this.minutes > 0) {
          this.minutes--;
          this.seconds = 59;
        } else {
          clearInterval(this.countdownTimer);
          this.days = 0;
          this.hours = 0;
          this.minutes = 0;
          this.seconds = 0;
        }
      } else {
        this.seconds--;
      }
    },
  },
  beforeUnmount() {
    clearInterval(this.countdownTimer);
  },
};
</script>

<style scoped></style>
